import { render, staticRenderFns } from "./structTypeF.vue?vue&type=template&id=24505c98&scoped=true&"
import script from "./structTypeF.vue?vue&type=script&lang=js&"
export * from "./structTypeF.vue?vue&type=script&lang=js&"
import style0 from "./structTypeF.vue?vue&type=style&index=0&id=24505c98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24505c98",
  null
  
)

export default component.exports